// extracted by mini-css-extract-plugin
module.exports = {"God":"BackgroundImage_God__10Yof"};